import http, { url } from '../../http'

const API_URL = "companies"

class itemsAPI {

  async save(items) { 
    const response = await http(`${API_URL}/puntation`, 'POST', items)
    return response
  }

}

export default new itemsAPI()